import React from 'react';

const UpdateProduct = () => {
    return (
        <div>
            <h2>Update Product</h2>
        </div>
    );
};

export default UpdateProduct;